import I18n from 'I18n';
import { Map as ImmutableMap, fromJS } from 'immutable';
import { useState } from 'react';
import { H7 } from 'foundations-components/transitional/components/H7';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { PropertyFilter } from 'customer-data-filters-ui/public/components';
import { htmlEscapedFilter, isHtmlFieldType, htmlNormalizedToTextFilter } from '../../filter-utils';
import { hasObjectTypeId } from '../../../../utils/source-utils';
// @ts-expect-error untyped import
import { getObjectTypeFamily } from '../../xo-filter-utils';
import debounce from 'react-utils/debounce';
import { getEventDateFilterProperty } from './event-date-filter-property';
import { useSnowflakeSourceData } from '../../../../metadata/sources';
// @ts-expect-error untyped import
import { useTableDescription, useTableSource } from '../SourceMeta';
import { findEventLikeTable, getTableLabel } from '../../../../utils/table-utils';
import { useSnowflakeEventDateStrategy } from '../../strategies/use-event-date-strategy';
// @ts-expect-error untyped import
import { EVENT_DATE_PROPERTY_NAME } from '../../event-date-interval-utils';
import { Small } from 'foundations-components/transitional/components/Small';
import { useCheckEventDateLimit } from './use-check-event-date-limit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useEventTable = () => {
  const tableDescription = useTableDescription();
  const {
    data: {
      snowflakeTables
    } = {},
    loading
  } = useSnowflakeSourceData();
  if (tableDescription == null) {
    throw new Error('EventDateIntervalFilter can only be rendered when there is a table description!');
  }
  const maybeEventLikeTable = findEventLikeTable(tableDescription, snowflakeTables || ImmutableMap());
  return {
    loading,
    maybeEventLikeTable
  };
};
export const NewEventDateFilterPanel = ({
  filter,
  onDone,
  onCancel
}) => {
  const property = getEventDateFilterProperty();
  const [draftFilter, setDraft] = useState(filter);
  const {
    maybeEventLikeTable: eventTableDescription,
    loading
  } = useEventTable();
  const {
    name: tableName
  } = eventTableDescription || {
    name: ''
  };
  const source = useTableSource(tableName);
  const tableLabel = getTableLabel(tableName, source);
  const {
    disabled,
    error,
    message: maybeDisabledMessage,
    maxDays
  } = useCheckEventDateLimit(draftFilter, tableLabel, source === null || source === void 0 ? void 0 : source.dataSourceId);
  if (source == null && !loading) {
    throw new Error('PropertyFilterPanel can only be rendered when there is a table description in the report!');
  }
  if (error) {
    console.error('Could not retrieve event date limit');
  }
  let {
    filter: propertyFilter
  } = draftFilter;
  if (isHtmlFieldType(property)) {
    propertyFilter = htmlNormalizedToTextFilter(draftFilter).filter;
  }
  const filterFamily = hasObjectTypeId(source) ? getObjectTypeFamily(source.objectTypeId) : source.dataSourceId;
  const strategy = useSnowflakeEventDateStrategy({
    source
  });
  const handleChange = (value, info) => {
    if (!value || info.hasIncompleteFilters || info.hasFilterValidationErrors) {
      return;
    }
    const nextFilter = filter.set('filter', fromJS(value));
    if (isHtmlFieldType(property)) {
      const updatedFilter = htmlEscapedFilter(nextFilter);
      setDraft(updatedFilter);
    } else {
      setDraft(nextFilter);
    }
  };
  const debouncedHandleChange = debounce(handleChange, 300);
  const handleDone = () => {
    onDone({
      draftFilter
    });
  };
  if (!strategy) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "filter-edit-panel",
    children: [/*#__PURE__*/_jsx(H7, {
      marginBlockEnd: "0",
      children: property.label || property.name
    }), /*#__PURE__*/_jsx(PropertyFilter, {
      requiredPropertyName: EVENT_DATE_PROPERTY_NAME,
      filterFamily: filterFamily,
      hidePropertySelect: true,
      onChange: debouncedHandleChange,
      strategy: strategy,
      value: propertyFilter.toJS(),
      use: "vertical"
    }), /*#__PURE__*/_jsx(Small, {
      children: I18n.text('reporting-snowflake.filter-editor.event-date-filter.max-event-interval-msg', {
        maxDays,
        tableLabel
      })
    }), /*#__PURE__*/_jsx(TFlex, {
      justify: "between",
      marginBlockStart: "400",
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Tooltip, {
          disabled: !maybeDisabledMessage,
          title: maybeDisabledMessage,
          placement: "top right",
          children: /*#__PURE__*/_jsx(Button, {
            use: "tertiary",
            size: "xs",
            "data-test-id": "filter-editor-panel-apply-btn",
            disabled: disabled,
            onClick: handleDone,
            children: I18n.text('reporting-snowflake.filter-editor.editor-panel.apply')
          })
        }), /*#__PURE__*/_jsx(Button, {
          use: "tertiary-light",
          size: "xs",
          onClick: onCancel,
          children: I18n.text('reporting-snowflake.filter-editor.editor-panel.cancel')
        })]
      })
    })]
  });
};